import util from "../BsUtil"
import Env from "../BsGetEnv";
import BsGetXcx from "../BsGetXcx";
function getApplationCid() {
    return new Promise((resolve)=>{
        try {
            if(!window.DIDASDK){
                resolve({message:'DIDASDK没有引入！'});
                return;
            }
            let timer = setTimeout(()=>{
                resolve({});
                clearTimeout(timer);
                timer = null;
            }, 1000);
            window.DIDASDK.invoke('getUserInfo',{},res => {
                clearTimeout(timer);
                if (res) {
                    const obj = JSON.parse(res) || {}
                    resolve({
                        access_token  : obj.access_token  ,
                        cid : obj.cid 
                    });
                } else {
                    resolve({});
                }
            })
        } catch (error) {
            resolve({});
        }
    })
}
async function GetCid(){
    if(Env.inApplication && Env.isDidaPinche){
        return await getApplationCid();
    }
    let cid = util.queryString('cid') || util.queryString('user_cid') || util.queryString('userCid') || sessionStorage.getItem('cid') ||'' ;
    let access_token = encodeURIComponent(util.queryString('access_token')) || sessionStorage.getItem('access_token') || '';
    cid = encodeURIComponent(cid)

    if(!cid || !access_token){
        if(Env.inApplication){
            return await getApplationCid();
        } else {
            // {isAli: false,isWx: false}
            let xcx = await BsGetXcx()
            if(!(xcx.isAli || xcx.isWx)){
                cid = cid || util.getCookie('cid');
                access_token =  access_token || util.getCookie('access_token')
            }
        }
    }
    return {
        access_token,
        cid
    }
};
let user = GetCid();
export default async function(flag){
    if(flag){
        user = GetCid();
    }
    return await user;
}


